var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":12}})
}
var staticRenderFns = []

export { render, staticRenderFns }